import { render, staticRenderFns } from "./CustomerAssetUploadInfo.vue?vue&type=template&id=24a653bc&scoped=true&"
import script from "./CustomerAssetUploadInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerAssetUploadInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAssetUploadInfo.vue?vue&type=style&index=0&id=24a653bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a653bc",
  null
  
)

export default component.exports